module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "int",
      "title": "Introduction"
    }
  }, [_c('p', {
    staticClass: "h2_1"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ix",
      "title": "ix"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#rint"
    }
  }, [_vm._v("INTRODUCTION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#/text/Contents#rint"
    }
  }, [_vm._v("RENÉE WATSON")])])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "epig"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("We cannot create what we can’t imagine.")])]), _vm._v(" "), _c('div', {
    staticClass: "top1"
  }, [_c('p', {
    staticClass: "epig1"
  }, [_vm._v("—LUCILLE CLIFTON")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("L")]), _vm._v("et’s imagine a world where women are seen as whole beings and not as body parts, quests to be conquered, or damsels to be rescued. Let’s imagine a world where women save their own days, save the world, even.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Let’s imagine women as hunters.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I have always been drawn to female characters who chase, pursue, explore, interrogate, rescue. Kill, even. Every good story has a character who desperately wants something. But too often the desires of female characters revolve around clichés—gaining the affection of a man or wanting to be popular at almost any cost.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But not here. This is a collection of tales that have imagined worlds where women are on the hunt, where women are in search of their own independence, of finding what will truly quench their "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_x",
      "title": "x"
    }
  }, [_vm._v("physical, spiritual, and emotional hunger. These are women who will sacrifice and risk all for who and what they love, what they need, what they want. They are wise and they are strong. They are like the women I know in my real life who are often criticized, undervalued, silenced, or invisible.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Here, in these pages, a space has been created for their stories to be told. I believe we so desperately need these kinds of spaces—books, classrooms, writing workshops, community centers, homes—where women from all backgrounds can be seen and heard. These imaginary and actual spaces influence each other. If reality is flawed with sexist stereotypes and expectations, I should be able to read a story, a poem, and see what the world could be when characters prove to be more than those assumptions. When literature fails to show the myriad of experiences of what it means to "), _c('i', [_vm._v("act like a girl")]), _vm._v(", I should be able to look in my world and find many examples of girls and women living life on their own terms. What we experience, what we imagine, and what we create are always in conversation with each other.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This collection is a space where that conversation lives. Some of these women I feel like I’ve met before. Some of them have traits I recognize in myself. Others feel so outside of what I am used to, "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xi",
      "title": "xi"
    }
  }, [_vm._v("what I know. They all have a place here, and because they do, they can influence and impact what is created and imagined about women.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Here, Mulha, a fourteen-year-old South African girl, comes face-to-face with a monster and does not “waste time crying.” She does not crumble under adversity but instead finds light even in the darkest of circumstances. The thing that should destroy her becomes a means of provision. Mulha’s story reminds me of the women who raised me, who made a way out of no way, who found joy when all there seemed to be around them was pain and sorrow. There is a space for them here. Mulha’s story validates the years of waiting on an answer to a prayer, on the sweet redemption that comes after years of being forgotten and overlooked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In these pages, Elsa in “Elsa and the Evil Wizard” makes space for women determined to stand on their own two feet. Elsa refuses to be wooed by an arrogant suitor who only values her physical beauty and has no interest in who she really is. What I love about Elsa, and women like her, is her willingness to take a stand not just for herself but also for all types of women who deserve to be seen. Elsa uses her smarts to rescue herself, yes, but then she goes beyond self-preservation and devises a plan so that no other girl is preyed upon by this evil wizard.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xii",
      "title": "xii"
    }
  }, [_vm._v("In the tale of “The Husband Who Stayed Home,” we meet a brilliant wife who switches roles with her husband, proving she can do everything he does and not only be good at it, but can also rescue him from the disaster he creates when he tries to take care of her responsibilities. She is not shy about her capabilities. She isn’t self-deprecating and doesn’t downplay the fact that she can do many things well. Once she is out of the box, she refuses to be put back in. She has outgrown its boundaries.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the Zuni tale, “The Hunter Maiden,” we meet a girl who has the bold belief that there is no reason why she shouldn’t be able to hunt. Her brothers are dead and her father is too feeble. There is no other option for this girl—if her family doesn’t eat, her family will starve, die. The stakes are too high for her to stay in a girl’s place and play by the rules. She must do “the dangerous thing.” She has to.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And so do we.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In our real lives—whether writer or reader, scholar or student—we must do the dangerous things: challenge oppressive systems, take risks to go after the thing that will feed us, nurture us. We must provide spaces for diverse stories to be told and heard. The exchange of stories reminds us of each other’s humanity. The imagined story gives us an opportunity to create a new world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xiii",
      "title": "xiii"
    }
  }, [_vm._v("This collection has brought together a diverse cast of women who, individually, are remarkable and intriguing. Together, they are powerful. There is strength in this collection. There are no easy solutions for our heroines; there are no princes who come to make everything better with just one kiss. These stories tell girls it is okay to be afraid, to be flawed, to be hungry, to be curious, to be angry. These are complex characters who are perfectly imperfect, who don’t need fixing, per se, but rather a space to exist "), _c('i', [_vm._v("as is")]), _vm._v(". Imagine it.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In some ways, "), _c('i', [_vm._v("The Hunter Maiden")]), _vm._v(" reminds me of the gatherings I often have with friends—sometimes brunch or sometimes a meet up at home. We gather, all of us so different from each other, all of us bringing our stories of loving, parenting, creating, living, womaning to the group. It is there, in that place, during the exchange of stories, that we bear witness to each other, that we heal, that we question, that we imagine the world we want to create.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I am thankful for those women. I am thankful for this collection. Both provide a space for women to "), _c('i', [_vm._v("be")]), _vm._v(".")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e009d4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Introduction.vue
// module id = 69
// module chunks = 0